import { module } from 'angular';
import templateBuilderKtableDisplay from './builder/display.html';

export default module('app').run(/* @ngInject */ (
	/** @type {import('angular').ITemplateCacheService} */ $templateCache,
) => {
	$templateCache.put('kform/components/cardgrid/display.html', templateBuilderKtableDisplay);
});
